export enum CipherType {
  Login = 1,
  SecureNote = 2,
  Card = 3,
  Identity = 4,
  TOTP = 5,
  CryptoWallet = 7,
  MasterPassword = 8,
  DriverLicense = 9,
  CitizenID = 10,
  Passport = 11,
  SocialSecurityNumber = 12,
  WirelessRouter = 13,
  Server = 14,
  APICipher = 15,
  Database = 16,

  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Secret = 5,
  Environment = 6,
  LeakedSecret = 17,
}
